const PropTypes = require('prop-types');
const React = require('react');

const { UserStore } = require('@reverbdotcom/discovery-ui');
const UrlHelpers = require('components/shared/url_helpers.js');
const PromoProduct = require('./promo_product.jsx');
const CSRFForm = require('../shared/csrf_form.jsx');
const Savings = require('./savings.jsx');
const PriceWithChange = require('./price_with_change.jsx');
const ProductBundleCalculator = require('./product_bundle_calculator.js');

class ProductBundle extends React.Component {
  get renderingBundle() {
    return this.props.productBundle.id;
  }

  renderBundledListings() {
    return this.props.productBundle.bundled_products.map((bundledProduct) =>
      <PromoProduct
        key={bundledProduct.listing.id}
        listing={bundledProduct.listing}
        discountedPrice={bundledProduct.listing.price}
        originalPrice={bundledProduct.listing.original_price}
      />
    );
  }

  renderSavings() {
    return (
      <Savings
        price={ProductBundleCalculator.originalPrice(this.props.productBundle)}
        discountedPrice={ProductBundleCalculator.discountedPrice(this.props.productBundle)}
        symbol={this.props.productBundle.main_listing.price.symbol}
        bundledProductsCount={
          ProductBundleCalculator.bundledProductsCount(this.props.productBundle)
        }
      />
    );
  }

  renderHiddenData() {
    if (this.renderingBundle) {
      return (
        <input
          type="hidden"
          value={this.props.productBundle.id}
          name="cart_item[product_bundle_id]"
        />
      );
    }

    return (
      <div>
        <input
          type="hidden"
          value={this.props.productBundle.main_listing.id}
          name="cart_item[product_id]"
        />
        {
          this.props.productBundle.bundled_products.map((product) =>
            <input
              key={product.listing.id}
              type="hidden"
              value={product.listing.id}
              name="cart_item[product_ids][]"
            />
          )
        }
      </div>
    );
  }

  render() {
    if (!this.props.productBundle.bundled_products.length) { return false; }

    return (
      <div className="g-container">
        <div className="g-col-6 g-col-mobile-12">
          <PromoProduct
            listing={this.props.productBundle.main_listing}
            originalPrice={this.props.productBundle.main_listing.price}
          />
          {this.renderBundledListings()}
        </div>
        <div className="g-col-1 g-col-mobile-12" />
        <div className="g-col-5 g-col-mobile-12 align-center">
          <h4 className="heading-2 mt-1">
            <PriceWithChange price={ProductBundleCalculator.totalPrice(this.props.productBundle)} />
          </h4>
          {this.renderSavings()}
          <CSRFForm
            action={UrlHelpers.productBundleCartPath}
            method="POST"
            className="mt-1"
          >
            <input
              type="hidden"
              value={UserStore.getState().deviceType}
              name="cart_item[action_source_attributes][device]"
            />
            {this.renderHiddenData()}
            <button className="btn btn-primary wide">
              {
                I18n.t('js.productBundles.promo.addToCart', {
                  count: ProductBundleCalculator.bundledProductsCount(this.props.productBundle),
                  totalCount:
                    ProductBundleCalculator.bundledProductsCount(this.props.productBundle) + 1,
                })
              }
            </button>
          </CSRFForm>
        </div>
      </div>
    );
  }
}

ProductBundle.propTypes = {
  productBundle: PropTypes.object,
};

module.exports = ProductBundle;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/product_bundle.jsx